import classNames from 'classnames';
import * as React from 'react';

export declare interface IGenericErrorProps {
  errorContent?: string | React.ReactNode;
  showBorder?: boolean;
}

export default class GenericError extends React.PureComponent<IGenericErrorProps> {
  public static defaultProps: Partial<IGenericErrorProps> = {
    showBorder: true,
  };

  public render() {
    const { errorContent, showBorder } = this.props;
    const errorEmail = 'contact@opendoor.com';

    return (
      <div className={classNames('box', { 'no-shadow': !showBorder })}>
        <section className="text-center ">
          <h1>Oops, something went wrong</h1>
          {errorContent ? (
            errorContent
          ) : (
            <p>
              It looks like we ran into an issue. Please try again.
              <br />
              Email us at <a href={`mailto:${errorEmail}`}>{errorEmail}</a> if the problem persists.
            </p>
          )}
        </section>
      </div>
    );
  }
}
